// src/polyfills/fromEntries.js
if (!Object.fromEntries) {
  Object.fromEntries = function (iterable) {
    const obj = {};
    for (const [key, val] of iterable) {
      obj[key] = val;
    }
    return obj;
  };
}